module.exports = __webpack_public_path__ + "static/media/broker-area.d4ccaab1.png";